import { render, staticRenderFns } from "./DataSchool.vue?vue&type=template&id=2734ac0a&scoped=true&"
import script from "./DataSchool.vue?vue&type=script&lang=js&"
export * from "./DataSchool.vue?vue&type=script&lang=js&"
import style0 from "./DataSchool.vue?vue&type=style&index=0&id=2734ac0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2734ac0a",
  null
  
)

export default component.exports